__webpack_require__.p = "/reports-dashboard-templates-library/referrals-hub/";